import IntelliProveAPIError from './intelliprove_api_exception';

export default class IntelliProveNetworkError extends IntelliProveAPIError {
  constructor(msg: string) {
    super(msg, 0);
    Object.setPrototypeOf(this, IntelliProveNetworkError.prototype);
  }
}
